<div class="reset-page">
  <div class="reset-shell">
    <!-- ========================================= -->
    <!-- LEFT VISUAL PANEL -->
    <!-- ========================================= -->

    <div class="reset-visual">
      <div class="visual-content">
        <!-- Logo -->
        <!-- <div class="visual-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div> -->

        <!-- Illustration -->
        <div class="visual-image">
          <img
            src="assets/images/absences_lms_login_banner.png"
            alt="Password recovery"
          />
        </div>

        <!-- Footer -->
        <div class="visual-footer">
          <span>
            <i class="pi pi-lock"></i>
            Secure recovery
          </span>

          <span>
            <i class="pi pi-envelope"></i>
            Email verification
          </span>
        </div>
      </div>
    </div>

    <!-- ========================================= -->
    <!-- RIGHT FORM PANEL -->
    <!-- ========================================= -->

    <div class="reset-panel">
      <div class="reset-content">
        <!-- Mobile Logo -->
        <div class="mobile-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div>

        <!-- ===================================== -->
        <!-- RESET FORM -->
        <!-- ===================================== -->

        @if (!showMailConfirmation) {
        <div class="reset-header">
          <!-- <div class="reset-icon">
            <i class="pi pi-lock"></i>
          </div> -->
          <!-- <span class="reset-eyebrow"> Account recovery </span> -->
          <h2>Reset your password</h2>
          <p>
            Enter the email address linked to your account. We will send you a link to reset your password.
          </p>
        </div>
        <form [formGroup]="loginForm" novalidate class="reset-form">
          <!-- Email -->
          <div class="form-field">
            <label for="email_id"> Email address </label>
            <div class="input-wrapper">
              <i class="pi pi-envelope input-icon"></i>
              <input
                id="email_id"
                class="form-input"
                type="email"
                placeholder="Enter registered email"
                formControlName="email_id"
                autocomplete="email"
              />
            </div>
            <form-validation [control]="loginForm.controls.email_id">
            </form-validation>
          </div>
          <!-- Submit -->
          <button
            type="button"
            class="reset-button"
            [disabled]="!loginForm.valid"
            (click)="requestResetPassword(loginForm.value)"
          >
            <span>Send Reset Link</span>
            <i class="pi pi-arrow-right"></i>
          </button>
          <!-- Sign In -->
          <div class="login-section">
            <span>Already registered?</span>
            <a class="login-link" (click)="returnToLogin()"> Sign In </a>
          </div>
        </form>
        }

        <!-- ===================================== -->
        <!-- SUCCESS / EMAIL SENT -->
        <!-- ===================================== -->

        @if (showMailConfirmation) {
        <div class="confirmation-wrapper">
          <div class="confirmation-icon">
            <i class="pi pi-check"></i>
          </div>
          <span class="confirmation-eyebrow"> Email sent </span>
          <h2>Check your inbox</h2>
          <p>
            We've sent password reset instructions to your registered email
            address.
          </p>
          <div class="expiry-info">
            <i class="pi pi-clock"></i>
            <span>
              This reset link will expire within
              <strong>3 hours</strong>.
            </span>
          </div>
          <button type="button" class="reset-button" (click)="returnToVerify()">
            <span>Return to Verify OTP</span>
            <i class="pi pi-arrow-right"></i>
          </button>
        </div>
        }

        <!-- Security -->
        <div class="reset-security">
          <i class="pi pi-shield"></i>

          <span> If an account exists for employer@abc.com, a reset link is on its way. The confirmation state replaces the form after sending. </span>
        </div>
      </div>
    </div>
  </div>
</div>
